"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicesUISchemaMapper = servicesUISchemaMapper;
function makeServiceUISchema(key) {
    return {
        type: "Control",
        label: key,
        scope: `#/properties/${key}`,
        options: {
            format: "radio",
            hideIfUndefined: true,
        },
    };
}
function makeServicesUISchema(services, withFrequency) {
    const uiSchemaElements = [];
    for (let i = 0; i < services.length; i++) {
        const service = services[i];
        uiSchemaElements.push(makeServiceUISchema(service.shortHand));
        const serviceFrequency = withFrequency === null || withFrequency === void 0 ? void 0 : withFrequency.find(serviceFrequency => serviceFrequency.service === service.shortHand);
        if (serviceFrequency) {
            const serviceFrequencySchema = {
                type: "Control",
                scope: `#/properties/${serviceFrequency.key}`,
                options: {
                    hideIfUndefined: true,
                },
                rule: {
                    effect: "SHOW",
                    condition: {
                        scope: `#/properties/${service.shortHand}`,
                        schema: {
                            const: 1,
                        },
                    },
                },
            };
            uiSchemaElements.push(serviceFrequencySchema);
        }
    }
    return uiSchemaElements;
}
function servicesUISchemaMapper(template, services, serviceFrequencies) {
    template.uiSchema.elements = [
        ...makeServicesUISchema(services, serviceFrequencies),
    ];
    return template;
}
